import React from 'react';
import Select from 'react-select';
import clsx from 'clsx';
import atoms from 'ctsutheme/components/atoms';
import { emphasize, makeStyles, useTheme } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import { FasTimes } from 'assets/icons';
import {
  Control, NoOptionsMessage, Placeholder, Option, Menu, ValueContainer
} from './index';


const { IconButton } = atoms;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    height: 250
  },
  input: {
    display: 'flex',
    padding: 0,
    height: 'auto'
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center'
  },
  chip: {
    margin: theme.spacing(0.5, 0.25)
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    )
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2)
  },
  placeholder: {
    position: 'absolute',
    bottom: 6
  },
  paper: {
    position: 'absolute',
    zIndex: 2,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  }
}));

function MultiValue(props) {
  const {
    selectProps, children, removeProps, isFocused
  } = props;
  return (
    <Chip
      // variant="outlined"
      color="primary"
      size="small"
      tabIndex={-1}
      label={children}
      className={`${clsx(selectProps.classes.chip, {
        [selectProps.classes.chipFocused]: isFocused
      })} rounded color-black`}
      style={{ background: '#D1E1E9 linear-gradient(180deg,#D1E1E9,#88C7FD)' }}
      onDelete={removeProps.onClick}
      deleteIcon={(
        <IconButton
          {...removeProps}
          color="action"
        >
          <FasTimes />
        </IconButton>
)}
    />
  );
}

MultiValue.propTypes = {
  children: PropTypes.node,
  isFocused: PropTypes.bool
};

MultiValue.defaultProps = {
  children: [],
  isFocused: false
};

const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  MultiValue,
  ValueContainer
};

export const CTSUMuiMultiSelect = ({
  options,
  value,
  onChange,
  onInputChange,
  name,
  title,
  isValid,
  disabled
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const selectStyles = {
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      '& input': {
        font: 'inherit'
      }
    }),
    menuPortal: base => ({
      ...base,
      minWidth: '300px !important'
    })
  };
  const clsName = disabled ? 'Mui-disabled-style' : '';
  return (
    <Select
      classes={classes}
      styles={selectStyles}
      inputId="react-select-single"
      isClearable
      data-id={name}
      isValid={isValid}
      isDisabled={disabled}
      name={name}
      title={title}
      value={value}
      options={options}
      onChange={onChange}
      onInputChange={onInputChange}
      components={components}
      className={`input-react-multi-select ${clsName}`}
      isMulti
      menuPortalTarget={document.querySelector('body')}
    />
  );
};
